import { useRef } from "react";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { TiAffix, TiList, TiSearchBar, TiListRef } from "@ti/ui-mobile";
import { LeftOutline } from "antd-mobile-icons";
import { callNativeApi, flutterHandle } from "@/utils/nativeUtils";
import { useT } from "@/utils/intlUtils";
import { Auth } from "@/utils/authUtils";
import CreateButton from "../components/CreateButton";
import ListItem, { DataProps } from "./components/ListItem";
import Filter from "./components/Filter";
import { getMaterialApplyList } from "@/services/transfer";
import { SearchBar, ListContent, Page } from "./styles";
import useSearchStore from "@/pages/transfer/List/useSearchStore";

export default () => {
  const navigate = useNavigate();
  const t = useT();
  const [searchParam] = useSearchParams();

  const isShowBackIcon = searchParam.get("backIcon") === "true";

  const listRef = useRef<TiListRef | null>(null);

  const searchParams = useRef<Record<string, unknown> | undefined>({});

  const {
    searchSaveConfig = {
      key: "applicantName",
      label: t("申请人"),
      placeholder: t("请输入申请人"),
      keyword: "",
    },
    filterSaveConfig,
    setSearchSaveConfig,
    setFilterSaveConfig,
  } = useSearchStore();

  searchParams.current = filterSaveConfig;

  const searchConfig = [
    {
      key: "applicantName",
      label: t("申请人"),
      placeholder: t("请输入申请人"),
    },
    {
      key: "materialApplyId",
      label: t("审批单号"),
      placeholder: t("请输入审批单号"),
    },
    {
      key: "principalName",
      label: t("负责人"),
      placeholder: t("请输入负责人"),
    },
    {
      key: "transferCode",
      label: t("调拨单号"),
      placeholder: t("请输入调拨单号"),
    },
    {
      key: "transferApplyCode",
      label: t("调拨申请单"),
      placeholder: t("请输入调拨申请单"),
    },
    {
      key: "logisticsCode",
      label: t("物料单号"),
      placeholder: t("请输入物料单号"),
    },
  ];

  return (
    <Page
      title={t("物料调拨")}
      backIcon={
        isShowBackIcon ? <LeftOutline style={{ fontSize: 24 }} /> : <></>
      }
      onBack={() => {
        try {
          flutterHandle("flutter_back", "refresh");
        } catch (e) {
          navigate(-1);
        }
      }}
      extra={
        <Auth authKey="OAM_050401">
          <CreateButton />
        </Auth>
      }
    >
      <TiAffix offsetTop={45}>
        <SearchBar>
          <TiSearchBar
            configs={searchConfig}
            config={searchSaveConfig}
            onConfigChange={setSearchSaveConfig}
            showSearchText
            onSearch={() => {
              listRef.current?.onSearch();
            }}
          />
          <Filter
            value={filterSaveConfig}
            onSearch={(params) => {
              searchParams.current = {
                ...searchParams.current,
                ...params,
              };
              setFilterSaveConfig(searchParams.current);
              listRef.current?.onSearch();
            }}
          />
        </SearchBar>
      </TiAffix>
      <ListContent>
        <TiList.Select<DataProps>
          ref={listRef}
          presetItemStyle="card"
          rowKey="id"
          request={(params) =>
            getMaterialApplyList({
              ...params,
              types: "1,2,4",
              ...searchParams.current,
              [searchSaveConfig.key as string]: searchSaveConfig.keyword,
            })
          }
          renderItem={(record) => (
            <ListItem
              record={record}
              onClick={() => {
                callNativeApi("hideBottom", {});
                navigate({
                  pathname: `/transfer/detail/${record.id}`,
                });
              }}
            />
          )}
        />
      </ListContent>
    </Page>
  );
};
